module.exports = __webpack_public_path__ + "img/button.96fd5573.png";